import React from "react";

import Card from "../card";
import MainInput from "../input";
import MainImage from "../image";


const WizardFinalStep = ({
  item,
  deviceName,
  deviceDescription,
  setDeviceName,
  setDeviceDescription,
}) => {
  return (
    <Card title={item.defaultName || "title"} className={`wizard-card-item`}>
      <section>
        <section className="device-info-container">
          <section>
            <span className="device-kay">Comment:</span>
            <span className="device-value"> {item.comment}</span>
          </section>
          <section>
            <span className="device-kay">Fw. v.</span>
            <span className="device-value">{item.versionNumber} </span>
          </section>
        </section>
        <section className="device-input-container">
          <MainInput
            onChange={(e) => {
              setDeviceName(e);
            }}
            value={deviceName}
            label={"Name"}
          />
          <MainInput
            onChange={(e) => {
              setDeviceDescription(e);
            }}
            value={deviceDescription}
            label={"description"}
          />
        </section>
        <section className="img-container">
          <MainImage src={item.img} alt="Test img" />
        </section>
      </section>
    </Card>
  );
};

export default WizardFinalStep;
